/**
 * SITE-ADD-MODAL
 * Create new site from the map
 */
import Modal from "@/components/modal"
import { useState } from "react"
import TextInput from "@/components/text-input"
import siteStore from "../../model/site.store"
import { useAppSelector } from "@/core/root-reducer"

interface Props {
  title: string
  inputTitle?: string
  initialName?: string
  onClose: () => void
  onNext: (name: string) => void
}

export default function SiteAddModal(props: Props) {
  //Selectors
  const status = useAppSelector(siteStore.selectors.status)

  //State
  const [name, setName] = useState(props.initialName ?? "")

  return (
    <Modal
      status={status}
      onClose={() => props.onClose()}
      title={props.title}
      isCloseButtonVisible
      disableClickOutside
      onNext={name.length ? () => props.onNext(name) : undefined}>
      <TextInput title={props.inputTitle ?? "Nom du lieu"} value={name} onChange={(e) => setName(e.value)} autoFocus />
      <div className="h-40" />
    </Modal>
  )
}
